//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import anime from 'animejs';

export default {
  props: {
    people: Array,
  },
  data: function() {
    return {
      selectedPerson: this.people && this.people[0],
    };
  },
  methods: {
    selectPerson: function(person) {
      anime({
        targets: this.$refs.selectedPeopleContainer,
        opacity: 0,
        duration: 300,
        translateY: '-200px',
        easing: 'easeInOutSine',
      });

      setTimeout(() => {
        this.selectedPerson = person;

        anime({
          targets: this.$refs.selectedPeopleContainer,
          opacity: 1,
          translateY: 0,
          duration: 600,
          easing: 'easeInOutSine',
        });
      }, 300);
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/our-people/OurPeople.vue